module.exports = __webpack_public_path__ + "img/detail_portrait_default@3x.9698f0e1.png";